export default __webpack_public_path__ + "static/media/data-compare.ae2301fc.svg";